import React from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';

const GameKingEventEnd = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content'>
					<div className='game-king End'>
						<div className='visual'>
							<h1>
								<img
									src={`${IMG_URL}/images/gameking/tit_game_default.png`}
									alt='게임의 왕좌 타이틀'
								/>
							</h1>
							<p>
								<img
									src={`${IMG_URL}/images/gameking/img_event_end.png`}
									alt='이벤트 종료 안내'
								/>
							</p>
						</div>
						<div className='copy'>
							<p>
								지금까지 게임의 왕좌에
								<br /> 많은 관심을 보내주셔서 감사해요.
							</p>
							<p>
								아쉽지만, <strong>게임의 왕좌 이벤트는</strong> <br />{' '}
								<strong>잠시 종료</strong>되었음을 알려드려요.
							</p>
							<p>
								비글즈는 더 다양하고 재밌는
								<br /> 이벤트들과 함께 돌아오도록 할게요.
								<br /> 조금만 기다려주세요!
							</p>
						</div>
						<div className='floating'>
							<img
								src={`${IMG_URL}/images/gameking/logo_bigglz_end.png`}
								alt='bigglz'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GameKingEventEnd;
